import {AppResourceSearch, ApiFilter} from '@sellers-shield-home-protection/ss-core-js';
import {runAsPublic} from "./api-helper";
import {MD} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuStateAppResource';

export const enabledStatesCustomSelectRequestFilters = {
    pagination: 'disabled',
    filter: {
        params: {
            isEnabled: true,
        },
    },
};

export const fetchStates = async (searchData) => {
    let luStateAppResourceSearch;

    await runAsPublic(async () => {
        luStateAppResourceSearch = new AppResourceSearch('lu-state');

        await luStateAppResourceSearch.setSearchData(searchData);
        await luStateAppResourceSearch.search();
    });

    return luStateAppResourceSearch.appResourceCollection;
};

export const fetchEnabledStates = async () => {
    const searchData = {
        pagination: 'disabled',
        filter: new ApiFilter({
            params: {
                isEnabled: true,
            },
        }),
    };

    return await fetchStates(searchData);
};

export const findStatesByName = async (name) => {
    const searchData = {
        pagination: 'disabled',
        filter: new ApiFilter({
            params: {
                isEnabled: true,
                title: name,
            },
        }),
    };

    return await fetchStates(searchData);
};
export const getV2States = async () => {
    const v2States = ['Texas', 'South Carolina', 'North Carolina', 'Pennsylvania', 'Delaware', 'Maryland'];
    const searchData = {
        pagination: 'disabled',
    };

    let states = (await fetchStates(searchData)).toArray();
    return states.filter(state => v2States.includes(state.title));
};

export const stateHasHSLP = (stateSettings) => {
    return stateSettings.hslp === 1;
};

export const stateHasSellerFormSelection = (stateSettings) => {
    return stateSettings.is_selectable_by_seller === 1;
};

export const formDisclaimer = (state) => {
    switch(state?.id){
        case MD:
            return "Your client will have the option of completing either the Maryland Residential Property Disclaimer Statement or the Maryland Residential Property Disclosure Statement."
        default: 
            return null;
    }
};
